import * as types from '../constants';

export function loadDataMarketplaceCategories() {
  return {
    type: types.LOAD_DATA_MARKETPLACE_CATEGORIES,
  };
}

export function loadDataMarketplaceFeeds(categorySlug, filterParams) {
  return {
    type: types.LOAD_DATA_MARKETPLACE_FEEDS,
    categorySlug,
    filterParams,
  };
}

export function loadDataMarketplaceFeedOptions() {
  return {
    type: types.LOAD_DATA_MARKETPLACE_FEED_OPTIONS,
  };
}

export function downloadDataMarketplaceFeed(categorySlug, filename) {
  return {
    type: types.DOWNLOAD_DATA_MARKETPLACE_FEED,
    categorySlug,
    filename,
  };
}

export function clearDataMarketplaceFeeds() {
  return {
    type: types.CLEAR_DATA_MARKETPLACE_FEEDS,
  };
}
